export const safeNumber = (num)=>{
    if(isNaN(Number(num))) return 0;
    
    return Number(num)
}